// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.video-wrapper[data-v-179f30f0] {\n  position: relative;\n  width: 100%;\n  padding-bottom: 56.25%; /* 16:9 */\n  height: 0;\n}\n.video-wrapper iframe[data-v-179f30f0] {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  border-radius: 10px;\n}\n.placeholder-icon[data-v-179f30f0] {\n  font-size: 50px;\n  color: #bbb;\n  margin-bottom: 20px;\n}\n.video-content[data-v-179f30f0] {\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
